import { createElementBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref } from "vue";
import { useBindCx } from "@scalar/use-hooks/useBindCx";
//#region src/components/ViewLayout/ViewLayout.vue?vue&type=script&setup=true&lang.ts
var ViewLayout_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ViewLayout",
	setup(__props) {
		const { cx } = useBindCx();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", normalizeProps(guardReactiveProps(unref(cx)("flex flex-col min-h-0 flex-1 *:border-t first:*:border-t-0 md:*:border-t-0 xl:overflow-hidden md:flex-row leading-5"))), [renderSlot(_ctx.$slots, "default")], 16);
		};
	}
});
//#endregion
export { ViewLayout_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ViewLayout.vue.script.js.map